export default "__VITE_PUBLIC_ASSET__825ae485__"